function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #010101;\n        stroke: #000;\n        stroke-width: 0.391px;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "f_faceshape_v_vector-2",
  "data-name": "f_faceshape_v_vector",
  className: "cls-2",
  d: "M393.188,166.8c81.825-1,116.3,55.09,116.015,135.547,16.917-2.518,21.168,9.576,16.406,26.953-4.278,15.611-13.372,36.353-30.468,39.062-4.239,14.867-12.723,31.562-21.094,43.36q-9.374,12.5-18.75,25c-5.047,14.874-5.662,33.905-5.469,53.125l1.953,19.922c-4.846,10.588-17.758,22.221-26.562,29.3l-12.5,11.329c-5.013,7.707-5.353,19.881-12.5,25.39h-0.781c-5.18-7.395-6.964-18.658-12.5-26.172l-26.172-24.218-12.891-15.625c5.2-16.012,3.533-58.405-2.734-72.266l-16.8-19.531c-10.139-14.137-19.639-31.147-24.61-50-16.413-3.615-26.031-24.707-29.687-41.016-3.687-16.448,2-27.462,16.406-24.609-0.871-63.437,22.654-109.17,65.625-127.735,7.344-3.172,15.926-5.012,24.61-6.64Z"
});

var SvgFFaceshapeVVector = function SvgFFaceshapeVVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_faceshape_v_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFFaceshapeVVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_faceshape_v_vector.797e6d00.svg";
export { ForwardRef as ReactComponent };